import { z } from 'zod'
import { optionalText } from './common'

const companyFields = z.object({
  name: optionalText(200),
  hebrewName: optionalText(200),
  companyNumber: optionalText(30),
  entityNumber: optionalText(40),
})

/**
 * Companies are managed from the client card, so `clientId` comes from the route
 * and is not part of the payload.
 */
export const companyInputSchema = companyFields.superRefine((v, ctx) => {
  if (!v.name && !v.hebrewName) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ['hebrewName'],
      message: 'חובה למלא שם בעברית או שם באנגלית',
    })
  }
})

export type CompanyInput = z.infer<typeof companyInputSchema>

export type CompanyDto = {
  id: string
  clientId: string
  name: string | null
  hebrewName: string | null
  companyNumber: string | null
  entityNumber: string | null
  createdAt: string
  updatedAt: string
}
